export const formatWorkerTestContent = (result) => {
  if (!result) return '';

  if (result && typeof result === 'object' && 'body' in result) {
    const body = result.body;
    return typeof body === 'string' ? body : JSON.stringify(body, null, 2);
  }

  // Fallback for other cases
  return typeof result === 'string' ? result : JSON.stringify(result, null, 2);
};
